(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // header elevation + scroll progress
  var head = document.querySelector('[data-head]');
  var bar = document.querySelector('[data-scrollbar]');
  function onScroll() {
    var y = window.scrollY || 0;
    if (head) head.classList.toggle('is-scrolled', y > 40);
    if (bar) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // reveal on scroll
  var targets = [].slice.call(document.querySelectorAll('[data-reveal]'));
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
        if (en.target.hasAttribute('data-stats')) runStats(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
    setTimeout(function () { targets.forEach(function (el) { el.classList.add('is-in'); }); }, 3000);
  }

  // hero spec rules
  var spec = document.querySelector('[data-spec]');
  if (spec) setTimeout(function () { spec.classList.add('is-drawn'); }, 350);

  // stat count-up
  function runStats(scope) {
    [].slice.call(scope.querySelectorAll('[data-count]')).forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var dec = (el.getAttribute('data-count').split('.')[1] || '').length;
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce || !target) { el.textContent = target.toFixed(dec) + suffix; return; }
      var t0 = performance.now();
      (function tick(now) {
        var p = Math.min(1, (now - t0) / 900);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    });
  }

  // ritual cycle
  var steps = [].slice.call(document.querySelectorAll('[data-step]'));
  if (steps.length) {
    var i = 0, locked = false, timer;
    function show(n) { steps.forEach(function (s, k) { s.classList.toggle('is-active', k === n); }); }
    function advance() { if (!locked) { i = (i + 1) % steps.length; show(i); } }
    show(0);
    timer = setInterval(advance, 3200);
    steps.forEach(function (s, k) {
      function pick() {
        i = k; show(k); locked = true;
        clearTimeout(s._u);
        s._u = setTimeout(function () { locked = false; }, 6000);
      }
      s.addEventListener('mouseenter', pick);
      s.addEventListener('click', pick);
    });
    void timer;
  }

  // rotating reviews (auto-rotate + arrows + clickable dots)
  var voices = [].slice.call(document.querySelectorAll('[data-voice]'));
  var dots = [].slice.call(document.querySelectorAll('[data-voice-dot]'));
  if (voices.length > 1) {
    var v = 0, vTimer, vbox = document.querySelector('[data-voices]');
    function goV(n) {
      v = (n + voices.length) % voices.length;
      voices.forEach(function (el, k) { el.classList.toggle('is-on', k === v); });
      dots.forEach(function (el, k) { el.classList.toggle('is-on', k === v); });
    }
    function startV() { vTimer = setInterval(function () { goV(v + 1); }, 7000); }
    function resetV() { clearInterval(vTimer); startV(); }
    if (vbox) {
      vbox.addEventListener('mouseenter', function () { clearInterval(vTimer); });
      vbox.addEventListener('mouseleave', startV);
    }
    var vp = document.querySelector('[data-vprev]'), vn = document.querySelector('[data-vnext]');
    if (vp) vp.addEventListener('click', function () { goV(v - 1); resetV(); });
    if (vn) vn.addEventListener('click', function () { goV(v + 1); resetV(); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goV(k); resetV(); }); });
    startV();
  }

  // story slider (prev/next arrows + clickable timeline)
  var story = document.querySelector('[data-story]');
  if (story) {
    var track = story.querySelector('[data-track]');
    var slides = [].slice.call(story.querySelectorAll('.story-slide'));
    var sdots = [].slice.call(story.querySelectorAll('[data-go]'));
    var idxEl = story.querySelector('[data-idx]');
    var prevB = story.querySelector('[data-prev]'), nextB = story.querySelector('[data-next]');
    var s = 0;
    function goS(n) {
      s = Math.max(0, Math.min(slides.length - 1, n));
      if (track) track.style.transform = 'translateX(-' + (s * 100) + '%)';
      sdots.forEach(function (d, k) { d.classList.toggle('is-on', k === s); });
      slides.forEach(function (el, k) { el.classList.toggle('is-current', k === s); });
      if (idxEl) idxEl.textContent = s + 1;
      if (prevB) prevB.disabled = (s === 0);
      if (nextB) nextB.disabled = (s === slides.length - 1);
    }
    if (prevB) prevB.addEventListener('click', function () { goS(s - 1); });
    if (nextB) nextB.addEventListener('click', function () { goS(s + 1); });
    sdots.forEach(function (d, k) { d.addEventListener('click', function () { goS(k); }); });
    document.addEventListener('keydown', function (e) {
      var r = story.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        if (e.key === 'ArrowLeft') goS(s - 1);
        if (e.key === 'ArrowRight') goS(s + 1);
      }
    });
    goS(0);
  }

  // press logo wall -> read the quote inside
  var wall = document.querySelector('[data-wall]');
  if (wall) {
    var rq = document.querySelector('[data-pr-quote]'),
        ro = document.querySelector('[data-pr-outlet]'),
        rm = document.querySelector('[data-pr-meta]'),
        rr = document.querySelector('[data-pr-read]'),
        rd = document.querySelector('[data-reader]');
    [].slice.call(wall.querySelectorAll('[data-outlet]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        [].slice.call(wall.querySelectorAll('[data-outlet]')).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (rq) rq.textContent = btn.getAttribute('data-quote');
        if (ro) ro.textContent = btn.getAttribute('data-name');
        if (rm) rm.textContent = btn.getAttribute('data-meta');
        if (rr) {
          var u = btn.getAttribute('data-url');
          if (u) { rr.style.display = ''; rr.setAttribute('href', u); }
          else { rr.style.display = 'none'; }
        }
        if (rd) { rd.classList.remove('is-swap'); void rd.offsetWidth; rd.classList.add('is-swap'); }
      });
    });
  }

  // product gallery — swipeable carousel with dots
  [].slice.call(document.querySelectorAll('[data-gallery]')).forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var dots = [].slice.call(g.querySelectorAll('[data-gallery-dots] button'));
    if (!track || dots.length < 2) return;
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        ticking = false;
      });
    }, { passive: true });
  });

  // cart pulse on add
  [].slice.call(document.querySelectorAll('[data-add]')).forEach(function (form) {
    form.addEventListener('submit', function () {
      var c = document.querySelector('[data-cart-count]');
      if (!c) return;
      c.classList.add('is-pulsing');
      setTimeout(function () { c.classList.remove('is-pulsing'); }, 500);
    });
  });

  // offer popup
  var offer = document.querySelector('[data-offer]');
  if (offer) {
    var key = 'brushean_offer_v1';
    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) { seen = false; }
    var delay = (parseInt(offer.getAttribute('data-delay'), 10) || 60) * 1000;
    function close() {
      offer.classList.remove('is-open');
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }
    if (!seen) setTimeout(function () { offer.classList.add('is-open'); }, delay);
    [].slice.call(offer.querySelectorAll('[data-offer-close]')).forEach(function (b) {
      b.addEventListener('click', close);
    });
    offer.addEventListener('click', function (e) { if (e.target === offer) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offer.classList.contains('is-open')) close();
    });
    var f = offer.querySelector('form');
    if (f) f.addEventListener('submit', function () { try { localStorage.setItem(key, '1'); } catch (e) {} });
  }
})();
